import { Component } from '@angular/core';

@Component({
  selector: 'app-address-line-icon',
  templateUrl: './address-line-icon.component.html',
  styleUrls: ['./address-line-icon.component.scss']
})
export class AddressLineIconComponent {

}
